// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"39d8b75c","453":"4eb4973a","455":"4eca821e","977":"176baa06"}[chunkId] + ".chunk.js";
};